import { Injectable } from '@angular/core';
import { TaskGroupTypeCreateBody } from '@app/domain';
import { TaskGroupType } from '@app/domain/entities/task-group-type.entity';
import { TaskGroupTypeRepository } from '@app/domain/repositories/task-group-type.repository';
import { map, Observable } from 'rxjs';
import { TaskGroupTypeService } from '../api-clients/task-group-type.service';
import { TaskGroupTypeMapper } from '../mappers/task-group-type.mapper';

@Injectable()
export class TaskGroupTypeRepositoryImpl implements TaskGroupTypeRepository {
  private readonly _taskGroupTypeMapper = new TaskGroupTypeMapper();

  constructor(private readonly _taskGroupTypeService: TaskGroupTypeService) {}

  create(body: TaskGroupTypeCreateBody): Observable<TaskGroupType> {
    const createTaskGroupTypeDTO = this._taskGroupTypeService.create(body);

    return createTaskGroupTypeDTO.pipe(
      map(dto => this._taskGroupTypeMapper.taskGroupTypeListItemToDomain(dto))
    );
  }

  update(
    taskGroupTypeId: number,
    body: TaskGroupTypeCreateBody
  ): Observable<TaskGroupType> {
    const updateTaskGroupTypeDTO = this._taskGroupTypeService.update(
      taskGroupTypeId,
      body
    );

    return updateTaskGroupTypeDTO.pipe(
      map(dto => this._taskGroupTypeMapper.taskGroupTypeListItemToDomain(dto))
    );
  }

  getTaskGroupingTypes(): Observable<TaskGroupType[]> {
    const getTaskGroupingTypesDTO =
      this._taskGroupTypeService.getTaskGroupingTypes();

    return getTaskGroupingTypesDTO.pipe(
      map(dtos =>
        this._taskGroupTypeMapper.taskGroupTypeListItemsToDomain(dtos)
      )
    );
  }

  getAvailableBySectorId(sectorId: number): Observable<TaskGroupType[]> {
    const getAvailableBySectorIdDTO =
      this._taskGroupTypeService.getAvailableBySectorId(sectorId);

    return getAvailableBySectorIdDTO.pipe(
      map(dtos =>
        this._taskGroupTypeMapper.taskGroupTypeListItemsToDomain(dtos)
      )
    );
  }

  delete(taskGroupTypeId: number): Observable<void> {
    return this._taskGroupTypeService.delete(taskGroupTypeId);
  }
}
